import React from 'react'
import PropTypes from 'prop-types'
import { Text } from '@maui/elements'

const ListExpander = ({ total, type, expandHandler, expanded }) => (
  expanded
    ? <Text variant='body1' cursor='pointer' color='colorActionPrimary' onClick={expandHandler}>View less</Text>
    : <Text variant='body1' cursor='pointer' color='colorActionPrimary'onClick={expandHandler}>View all {total} {type}</Text>

)

ListExpander.propTypes = {
  expandHandler: PropTypes.func,
  expanded: PropTypes.bool,
  total: PropTypes.number,
  type: PropTypes.string
}

export default ListExpander
